module.exports = __webpack_public_path__ + "img/honor.75695c2d.png";